@if (heading && description) {
<h1 class="t-bold" [ngClass]="headingClass">{{ heading }}</h1>
}

<section [ngClass]="layout">
  @if (heading && !description) {
  <h1 class="t-bold" [ngClass]="headingClass">
    {{ heading }}
  </h1>
  } @if (description) {
  <p>{{ description }}</p>
  }
  <div class="actions">
    @if (btnText) {
    <un-button
      (click)="btnClick.emit()"
      [routerLink]="btnLink"
      [queryParams]="btnQuery"
      >{{ btnText }}</un-button
    >} @if (carousel.scrollWidth > el.nativeElement.scrollWidth) {
    <div class="scroll-btns">
      <un-button
        type="plain"
        [disabled]="carousel.scrollLeft === 0"
        (btnClick)="scrollLeft()"
      >
        <un-icon type="left" theme="outline"></un-icon>
      </un-button>
      <un-button
        type="plain"
        [disabled]="
          carousel.scrollLeft >
          carousel.scrollWidth - el.nativeElement.scrollWidth
        "
        (btnClick)="scrollRight()"
      >
        <un-icon type="right" theme="outline"></un-icon>
      </un-button>
    </div>
    }
  </div>
</section>
<div class="carousel-wrapper" #carousel [ngClass]="[layout, display]">
  <div class="carousel" [ngClass]="layout">
    <ng-content></ng-content>
  </div>
</div>
